import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "./components/ui/button";
import { Users, Gamepad2, CheckCircle2 } from "lucide-react";

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="bg-black text-white font-sans">
      {/* ================= HEADER ================= */}
      <nav className="fixed w-full z-50 bg-gradient-to-b from-black/70 via-black/40 to-transparent backdrop-blur-sm">
        <div className="container mx-auto px-6 py-4">
          <div className="flex justify-between items-center">
            <div className="text-2xl font-bold">
              Rivals <span className="text-emerald-400">Sportsbook</span>
            </div>
            <div className="flex items-center gap-3">
              <Button
                onClick={() => navigate("/signin")}
                variant="outline"
                className="border-gray-700 hover:bg-gray-800 hover:text-white"
              >
                Log In
              </Button>
              <Button
                onClick={() => navigate("/signup")}
                className="bg-emerald-500 hover:bg-emerald-600 text-white"
              >
                Sign Up
              </Button>
            </div>
          </div>
        </div>
      </nav>

      {/* ================= HERO ================= */}
      <section
        className="relative pt-40 pb-28 overflow-hidden bg-cover bg-center"
        style={{
          backgroundImage:
            "linear-gradient(180deg, rgba(0,0,0,0.35) 0%, rgba(0,0,0,0.7) 55%, rgba(0,0,0,0.95) 100%), url(/stadium.png)",
        }}
      >
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_35%,rgba(255,255,255,0.15),rgba(0,0,0,0.6)_55%,rgba(0,0,0,0.9)_100%)]" />

        <div className="container mx-auto px-6 relative z-10">
          <div className="grid md:grid-cols-2 gap-16 items-center -mt-6">

            {/* LEFT */}
            <div className="max-w-xl">
              <h1
                className="text-5xl md:text-6xl font-extrabold leading-tight drop-shadow-[0_8px_30px_rgba(0,0,0,0.55)]"
              >
                BET AGAINST <span className="text-emerald-400">REAL PEOPLE</span>, <br />
                NOT THE HOUSE.
              </h1>

              <p className="text-lg md:text-xl text-gray-300 mt-6 drop-shadow-[0_6px_20px_rgba(0,0,0,0.55)]">
                Challenge friends on games, wager peer-to-peer, and avoid the house
                edge. 100% social. 100% player vs player.
              </p>

              <div className="flex gap-4 mt-8">
                <Button
                  size="lg"
                  onClick={() => navigate("/signup")}
                  className="bg-emerald-500 hover:bg-emerald-600 px-8 text-lg shadow-lg shadow-emerald-500/20"
                >
                  Get Started
                </Button>
                <Button
                  size="lg"
                  variant="outline"
                  className="border-white/20 bg-black/30 text-white hover:bg-black/50"
                >
                  See How It Works
                </Button>
              </div>

              {/* PHONE (MOBILE) */}
              <div className="relative flex justify-center mt-10 md:hidden">
                <div className="absolute -inset-8 bg-emerald-500/20 blur-3xl rounded-full" />
                <img
                  src={require("./assets/rivalsOnIphone.png")}
                  className="w-[280px] drop-shadow-2xl -rotate-6"
                  alt="Rivals app"
                />
              </div>

              <div className="mt-10">
                <div className="text-sm uppercase tracking-[0.2em] text-gray-300/80">
                  How It Works
                </div>
                <div className="grid sm:grid-cols-2 gap-6 mt-4">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-full bg-emerald-500/15 flex items-center justify-center">
                      <Gamepad2 className="w-5 h-5 text-emerald-400" />
                    </div>
                    <div>
                      <div className="font-semibold">Create a Bet</div>
                      <div className="text-sm text-gray-400">
                        Choose a game and set your wager.
                      </div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-full bg-emerald-500/15 flex items-center justify-center">
                      <Users className="w-5 h-5 text-emerald-400" />
                    </div>
                    <div>
                      <div className="font-semibold">Challenge Other People</div>
                      <div className="text-sm text-gray-400">
                        Bet against friends or others around the world.
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* TRUST BADGES */}
              <div className="flex flex-wrap gap-6 mt-8 text-gray-300 text-sm">
                <div className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 h-4 text-emerald-400" />
                  No House Edge
                </div>
                <div className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 h-4 text-emerald-400" />
                  Secure & Private
                </div>
                <div className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 h-4 text-emerald-400" />
                  Fast Payouts
                </div>
              </div>
            </div>

            {/* PHONE */}
            <div className="relative justify-center -mt-4 hidden md:flex">
              <div className="absolute -inset-8 bg-emerald-500/20 blur-3xl rounded-full" />
              <img
                src={require("./assets/rivalsOnIphone.png")}
                className="w-[320px] md:w-[360px] drop-shadow-2xl -rotate-6"
                alt="Rivals app"
              />
            </div>
          </div>
        </div>
      </section>

      {/* ================= HOW IT WORKS ================= */}
      {/* <section className="py-28 bg-black border-t border-gray-800">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-5xl font-bold mb-16">How It Works</h2>

          <div className="grid md:grid-cols-3 gap-12">
            <div>
              <Gamepad2 className="mx-auto w-12 h-12 text-emerald-400 mb-6" />
              <h3 className="text-2xl font-semibold mb-4">Create Your Bet</h3>
              <p className="text-gray-400">
                Pick a game, set the terms, and choose your wager.
              </p>
            </div>

            <div>
              <Users className="mx-auto w-12 h-12 text-emerald-400 mb-6" />
              <h3 className="text-2xl font-semibold mb-4">Challenge Friends</h3>
              <p className="text-gray-400">
                Send bets directly or join public matchups.
              </p>
            </div>

            <div>
              <Trophy className="mx-auto w-12 h-12 text-emerald-400 mb-6" />
              <h3 className="text-2xl font-semibold mb-4">Winner Takes All</h3>
              <p className="text-gray-400">
                No house cut. The pot goes to the winner.
              </p>
            </div>
          </div>
        </div>
      </section> */}

      {/* ================= SOCIAL PROOF ================= */}
      <section className="py-20 bg-gray-900/40">
        <div className="max-w-5xl mx-auto px-6">
          <div className="rounded-2xl border border-white/10 bg-black/40 p-8 md:p-10">
            <p className="text-2xl md:text-3xl italic text-gray-200">
              “You’re not betting against a book — you’re betting against someone.”
            </p>
            <div className="mt-8 flex flex-wrap gap-6 text-xs md:text-sm uppercase tracking-[0.3em] text-gray-400">
              {/* <span>ESPN</span>
              <span>BETS</span>
              <span>SPORTING NEWS</span>
              <span>SPORTS</span>
              <span>YAHOO!</span> */}
            </div>
          </div>
        </div>
      </section>

      {/* ================= FINAL CTA ================= */}
      <section className="py-32 text-center">
        <h2 className="text-5xl font-bold mb-6">
          Ready to Bet Your Real People Around The World?
        </h2>
        <Button
          size="lg"
          className="bg-emerald-500 hover:bg-emerald-600 px-10 text-xl"
          onClick={() => navigate("/signup")}
        >
          Start Betting Now
        </Button>
      </section>

    </div>
  );
}
